import {
  Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges,
 } from '@angular/core';
 import {FormBuilder} from '@angular/forms';
 import {SelectValidationVm} from '../../../../view-model/select-validation/select-validation.vm';
 
 @Component({
   selector: 'app-select-method-message',
   templateUrl: './select-method-message.component.html',
   styleUrls: ['./select-method-message.component.scss'],
   providers: [FormBuilder],
 })
 export class SelectMethodMessageComponent implements OnInit, OnChanges {
   @Input() idPrefix = '';
   @Input() supportButton = false;
   @Input() customers;
   @Input() isModal = false;
   @Input() openModal = false;
   @Output() loggedIn = new EventEmitter<any>();
   @Output() selectMethod = new EventEmitter<any>();
   @Output() validateCode = new EventEmitter<any>();
   @Output() openValidateCodeModal = new EventEmitter<any>();
   @Output() validateCodeMode = new EventEmitter<any>();
   enableValidateCode = false;
   customer;
   options = [];
   customerId;
   selectSendOption = {
     bySMS: false,
     byCall: false,
     byEmail: false,
     byWhatsApp: false
   };
   dataMethodSelect;
   isLoading = false;
   successMessage = '';
   disableButton = false;
   public whatsAppNumber: any = null;
 
   constructor(private vm: SelectValidationVm) { }
 
   init() {
     this.enableValidateCode = false;
     this.customers.forEach(customer => {
       this.customerId = customer.idCustomer;
       customer.list.filter(element => {
         if(element.type === 'phone'){
           this.whatsAppNumber = {...element};
           this.whatsAppNumber.type = 'whatsapp';
           return this.whatsAppNumber;
         }
       });
       this.options = customer.list.filter(element => element.type!= 'whatsapp');
     });
   }
 
   selectOption(option) {
     const method = option.type;
     this.disableButton = !!option;
     this.selectSendOption = {
       bySMS: method === 'phone',
       byCall: method === 'call',
       byEmail: method === 'email',
       byWhatsApp: method === 'whatsapp',
     }
     this.dataMethodSelect = option;
   }
 
   onSuccess(event) {
     this.loggedIn.emit(event);
   }
 
   sendMessage() {
     this.isLoading = true;
 
     const dataSendCode = {
       ...this.selectSendOption,
       customerRef: this.customerId
     }
 
     this.vm.sendMessage(dataSendCode).subscribe(() => {
       if (this.isModal) {
         this.enableValidateCode = true;
         this.validateCodeMode.emit(true);
         return;
       }
       this.openValidateCodeModal.emit(true);
       this.isLoading = false;
     });
   }
 
   ngOnInit() {
     this.validateCodeMode.emit(false);
     this.init();
   }
 
   onValidateCode(event) {
     this.validateCode.emit(event);
   }
 
   ngOnChanges(changes: SimpleChanges): void {
     this.customer = changes.customers && changes.customers.currentValue ? changes.customers.currentValue[0] : '';
     if (this.isModal) {
       if (changes && changes.openModal && changes.openModal.currentValue && changes.openModal.currentValue.open) {
         this.init();
       }
     }
   }
 
   openSelectModal(){
     this.enableValidateCode = false;
     this.isLoading = false;
   }
 
   getImageMethod(option){
     switch (option) {
       case 'phone':
         return 'assets/svg/sms-modal.svg'
       case 'email':
         return 'assets/svg/mail-modal.svg';
       case 'call':
         return 'assets/svg/call.svg';
       case 'whatsapp':
         return 'assets/svg/whatsapp.png';
       default:
         break;
     }
   }
 
   getLabelMethod(option){
     switch (option) {
       case 'phone':
         return 'Enviar código por SMS'
       case 'email':
         return 'Enviar código por correo electrónico';
       case 'call':
         return 'Enviar código por Llamada telefónica';
       case 'whatsapp':
         return 'Enviar código por WhatsApp';
       default:
         break;
     }
   }
 }
 